import { BannerSlideButton } from '../../../interface/interface';

const CarouselButton = ({
  button,
}: Readonly<{ button: BannerSlideButton }>) => {
  const className = `inline-flex w-fit items-center justify-center rounded-full
    bg-primary-blue-500 px-6 py-3 text-xs font-semibold uppercase tracking-wide
    text-white transition-colors duration-200 hover:bg-primary-blue-600
    focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
    focus-visible:outline-primary-blue-500 sm:text-sm`;

  if (button.href) {
    return (
      <a
        href={button.href}
        aria-label={button.ariaLabel ?? button.label}
        onClick={button.onClick}
        className={className}
      >
        {button.label}
      </a>
    );
  }

  return (
    <button
      type="button"
      aria-label={button.ariaLabel ?? button.label}
      onClick={button.onClick}
      className={className}
    >
      {button.label}
    </button>
  );
};

export default CarouselButton;
